/* eslint-disable react/prop-types -- project uses JSX without PropTypes package */
import { useEffect, useRef, useState } from "react";
import CloseIcon from "../../assets/svg/icon_close.svg?react";

export default function EditableBrandTag({
  brand,
  isEditing,
  onBeginEdit,
  onCommit,
  onCancel,
  onDeleteClick,
  disabled,
}) {
  const [draft, setDraft] = useState(brand.name);
  const inputRef = useRef(null);

  useEffect(() => {
    setDraft(brand.name);
  }, [brand.name]);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [isEditing]);

  const commit = () => {
    onCommit(draft);
  };

  if (isEditing) {
    return (
      <span className="inline-flex items-center rounded-full bg-primary text-white pl-3 pr-1 py-1 text-sm font-medium shadow-sm max-w-full">
        <input
          ref={inputRef}
          className="bg-transparent text-white placeholder-white/70 outline-none min-w-[100px] max-w-[200px]"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onBlur={() => commit()}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              commit();
            }
            if (e.key === "Escape") {
              e.preventDefault();
              setDraft(brand.name);
              onCancel();
            }
          }}
          aria-label="Edit brand name"
        />
        <button
          type="button"
          className="p-1 rounded-full hover:bg-white/15 ml-1"
          onMouseDown={(e) => e.preventDefault()}
          onClick={onDeleteClick}
          title="Remove brand"
          aria-label={`Remove ${brand.name}`}
        >
          <CloseIcon className="w-4 h-4" aria-hidden />
        </button>
      </span>
    );
  }

  return (
    <div
      className={`inline-flex items-center rounded-full bg-primary text-white text-sm font-medium shadow-sm max-w-full ${
        disabled ? "opacity-60 pointer-events-none" : ""
      }`}
    >
      <button
        type="button"
        className="pl-4 pr-1 py-1.5 truncate max-w-[200px] text-left hover:opacity-95"
        onClick={() => onBeginEdit()}
        title="Click to rename"
      >
        {brand.name}
      </button>
      <button
        type="button"
        className="p-1.5 pr-2 rounded-full hover:bg-white/15 shrink-0"
        onClick={(e) => {
          e.stopPropagation();
          onDeleteClick();
        }}
        title="Remove brand"
        aria-label={`Remove ${brand.name}`}
      >
        <CloseIcon className="w-4 h-4" aria-hidden />
      </button>
    </div>
  );
}
